// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_apexcharts_dist_apexcharts_esm_js":"44178c4e9cd09d1e","node_modules_superset-ui_embedded-sdk_lib_index_js":"d3123f1136d6db62"}[chunkId] + ".js";
};